// extracted by mini-css-extract-plugin
export default {"container":"jq-z","ratingLayout":"kq-z","ratingLabel":"lq-z","nonInteractiveRatingLabel":"mq-z"};